import React, { useEffect, useRef } from 'react';
import './GameLog.css';

const COLOR_LABEL = { WHITE: '白', BLUE: '蓝', GREEN: '绿', RED: '红', BLACK: '黑', GOLD: '金' };

function formatEntry(entry, userMap) {
  const name = userMap[entry.player_id] || `Player ${entry.player_id}`;

  switch (entry.action) {
    case 'take_tokens': {
      const counts = {};
      (entry.colors || []).forEach((c) => { counts[c] = (counts[c] || 0) + 1; });
      const parts = Object.entries(counts).map(([c, n]) => `${COLOR_LABEL[c]}×${n}`);
      return { name, text: `拿取了 ${parts.join('、')}`, icon: '💎' };
    }
    case 'buy_card': {
      const card = entry.card;
      if (card) {
        const pts = card.points ? `${card.points}分` : '';
        return { name, text: `购买了${COLOR_LABEL[card.color]}${pts ? `(${pts})` : ''}卡`, icon: '🛒' };
      }
      return { name, text: '购买了一张卡', icon: '🛒' };
    }
    case 'reserve_card': {
      const card = entry.card;
      if (card) {
        return { name, text: `预定了${COLOR_LABEL[card.color]}卡`, icon: '📋' };
      }
      return { name, text: `盲预定了第${entry.tier}层卡`, icon: '📋' };
    }
    case 'acquire_noble':
      return { name, text: `获得了贵族 #${entry.noble_id}`, icon: '👑' };
    default:
      return { name, text: entry.action, icon: '•' };
  }
}

export default function GameLog({ log, userMap }) {
  const endRef = useRef(null);
  const entries = log || [];

  useEffect(() => {
    if (typeof endRef.current?.scrollIntoView === 'function') {
      endRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [entries.length]);

  return (
    <div className="game-log">
      <h3>行动日志</h3>
      <div className="game-log__list">
        {entries.length === 0 && (
          <div className="game-log__empty">暂无行动</div>
        )}
        {entries.map((entry, i) => {
          const { name, text, icon } = formatEntry(entry, userMap);
          return (
            <div key={i} className="game-log__entry">
              <span className="game-log__icon">{icon}</span>
              <span className="game-log__round">R{entry.round}</span>
              <span className="game-log__name">{name}</span>
              <span className="game-log__text">{text}</span>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
    </div>
  );
}
